/**
 * @flow
 * @relayHash 334cc549226f3a4e15c5d8528646f561
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceListContainer_viewer$ref = any;
export type InvoiceStatus = "ALL" | "OUTSTANDING" | "PAID" | "PAST_DUE" | "%future added value";
export type InvoiceQuery_Invoices_QueryVariables = {|
  count: number,
  cursor?: ?string,
  status?: ?InvoiceStatus,
|};
export type InvoiceQuery_Invoices_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: InvoiceListContainer_viewer$ref
  |}
|};
export type InvoiceQuery_Invoices_Query = {|
  variables: InvoiceQuery_Invoices_QueryVariables,
  response: InvoiceQuery_Invoices_QueryResponse,
|};
*/


/*
query InvoiceQuery_Invoices_Query(
  $count: Int!
  $cursor: String
  $status: InvoiceStatus
) {
  viewer {
    ...InvoiceListContainer_viewer_4qXjrI
    id
  }
}

fragment InvoiceListContainer_viewer_4qXjrI on User {
  invoices(status: $status, first: $count, after: $cursor) {
    edges {
      node {
        id
        title
        status
        total_cents
        outstanding_cents
        workspaces(first: 1) {
          edges {
            node {
              event {
                id
                title
              }
              id
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "status",
    "type": "InvoiceStatus",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor",
    "type": "String"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count",
    "type": "Int"
  },
  {
    "kind": "Variable",
    "name": "status",
    "variableName": "status",
    "type": "InvoiceStatus"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "InvoiceQuery_Invoices_Query",
  "id": null,
  "text": "query InvoiceQuery_Invoices_Query(\n  $count: Int!\n  $cursor: String\n  $status: InvoiceStatus\n) {\n  viewer {\n    ...InvoiceListContainer_viewer_4qXjrI\n    id\n  }\n}\n\nfragment InvoiceListContainer_viewer_4qXjrI on User {\n  invoices(status: $status, first: $count, after: $cursor) {\n    edges {\n      node {\n        id\n        title\n        status\n        total_cents\n        outstanding_cents\n        workspaces(first: 1) {\n          edges {\n            node {\n              event {\n                id\n                title\n              }\n              id\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "InvoiceQuery_Invoices_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "InvoiceListContainer_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "status",
                "variableName": "status",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "InvoiceQuery_Invoices_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoices",
            "storageKey": null,
            "args": v1,
            "concreteType": "InvoiceConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Invoice",
                    "plural": false,
                    "selections": [
                      v2,
                      v3,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "status",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "total_cents",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "outstanding_cents",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "workspaces",
                        "storageKey": "workspaces(first:1)",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1,
                            "type": "Int"
                          }
                        ],
                        "concreteType": "WorkspaceConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "WorkspaceEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Workspace",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "event",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Event",
                                    "plural": false,
                                    "selections": [
                                      v2,
                                      v3
                                    ]
                                  },
                                  v2
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cursor",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "endCursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasNextPage",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoices",
            "args": v1,
            "handle": "connection",
            "key": "InvoiceList_invoices",
            "filters": [
              "status"
            ]
          },
          v2
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '85f9c21b3c8cf23d9d2246126518156e';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/routes/__generated__/InvoiceQuery_Invoices_Query.graphql.js